import axios from "axios";
import {
  createStore,
  createEffect,
  createEvent,
} from "effector";
import { getCustomUserAgent } from "../common/customUserAgent";

export interface ICompany {
  id: string;
  name: string;
}
export const $companies = createStore<ICompany[]>([]);

export const queryCompanies = createEffect<void, ICompany[]>();

export const setCompanies = createEvent<ICompany[]>("");

$companies.on(queryCompanies.doneData, (_, val) => val);

//edited
queryCompanies.use(() =>
  axios.get("https://izba.kras-abs.ru/api/v3/auth/companies",
    {
      headers: {
        accept: "*/*",
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    })
    .then((res) => {
      if (res.data.companies == undefined) {
        return [] as ICompany[]
      }
      return (res?.data.companies ?? []) as ICompany[]
    })
);

export const refreshCompanies = () => {
  axios.get("https://izba.kras-abs.ru/api/v3/auth/companies",
    {
      headers: {
        accept: "*/*",
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    })
    .then((res) => {
      if (res.data.companies == undefined) {
        return [] as ICompany[]
      }
      return (res?.data.companies ?? []) as ICompany[]
    })
};


